import { useState } from 'react';
import { StateCountyTree } from 'components/state-county-tree';
import type { FilterTemplateProps } from '../../types';
import { useModalFacets, useCategoryFields } from '../template-hooks';
import style from '../filter-modal.module.scss';

// The State → County tree over the modal's facets. State and County are
// independent filters (`param` / `childParam`), ANDed on the backend.
export const StateCountyTreeTemplate = ({
  category,
  formValues,
  onFormChange,
}: FilterTemplateProps) => {
  const facets = useModalFacets();
  const [field] = useCategoryFields(category, 'tree-table');
  // Held here, above the tree: the tree unmounts whenever facets go empty (a
  // fresh search with no results), so owning the search text and expanded set
  // here keeps them from resetting underneath the reviewer.
  const [search, setSearch] = useState('');
  const [expandedIds, setExpandedIds] = useState<Record<string, boolean>>({});

  if (!field) return null;
  const stateBuckets = facets?.[field.facetKey]?.buckets ?? [];
  if (stateBuckets.length === 0) {
    return (
      <p className={style.emptyHint}>
        Run a search first to see available options
      </p>
    );
  }

  return (
    <StateCountyTree
      states={stateBuckets}
      counties={facets?.[field.childFacetKey]?.buckets ?? []}
      selectedStates={(formValues[field.param] as string[] | undefined) ?? []}
      selectedCounties={
        (formValues[field.childParam] as string[] | undefined) ?? []
      }
      onStatesChange={(ids) =>
        onFormChange(field.param, ids.length ? ids : undefined)
      }
      onCountiesChange={(ids) =>
        onFormChange(field.childParam, ids.length ? ids : undefined)
      }
      search={search}
      onSearchChange={setSearch}
      expandedIds={expandedIds}
      onExpandedIdsChange={setExpandedIds}
    />
  );
};
